export enum ProjectStatusEnum {
  All,
  Created,
  ReadyForApproval,
  Approved,
  Denied,
  SupplementRequested,
}
